import keyMirror from '../utils/keyMirror';

export const WIN_STATUS = keyMirror({
    APPROVED: null,
    PENDING: null,
    REJECTED: null,
    CANCELLED : null
});

export const WIN_TYPES = {
    'AB': 'Absolute',
    'IW': 'Informational Window',
    'MT': 'Meeting',
    'SP': 'Split Window',
    'TW': 'Terminal Window',
    'UN': 'Under Traffic'
};

/**
 * Business Rule: Informational Window will be available to select IF AND ONLY IF 
 * the window gang id is subset of INFORMATIONAL_GANGIDS.
 */
export const INFORMATIONAL_GANGIDS = [
    'FOREIGN RAILRD',
    'PUBLIC PROJECTS',
    'UNMANNED GEO CAR'
];

export const TRACK_TYPES = {
    "5": "Siding",
    "6": "Yard",
    "7": "Back",
    "8": "Crossover",
    "B": "Branch",
    "I": "Industry",
    "M": "Main"
};

export const TRACK_TYPE_SORT_INDEX = {
    MAIN: 0,
    SIDING: 1,
    CROSSOVER: 2,
    BACK: 3,
    YARD: 4,
    INDUSTRY: 5
};

// delimiter between track type and number
// can be either space or '-'
export const TRACK_DELIMITER_REGEX = /[\s-]+/;

//set deadline for the division to be able to create a win
export const DIVISION_MIN_DATE_TIME_CONFIG = {
    "KS" : {"deadlineDay" : "wednesday", "deadlineTime" : "15:00"},
    "DEFAULT" : {"deadlineDay" : "tuesday", "deadlineTime" : "23:59"}
}
